import * as React from "react";
import Popper from "@mui/material/Popper";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import {
  RightAlignedContainer,
  RoundPlusIcon,
  SelectPopperList,
  SelectPopperListItem,
  SelectPopperListItemText,
  SelectPopperWrapper,
} from "./BenevvPopper.styles";

export type PopperListItem = {
  text: string;
  onClick: () => void;
};

export interface BenevvPopperSelectProps {
  items: PopperListItem[];
}

export default function BenevvPopperSelect({ items }: BenevvPopperSelectProps) {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const iconRef = React.useRef<HTMLDivElement | null>(null); // Assume RoundPlusIcon is rendered as a div.

  const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
    // Assuming RoundPlusIcon renders to a div
    if (anchorEl) {
      setAnchorEl(null);
    } else {
      setAnchorEl(event.currentTarget);
    }
  };

  const handleClose = (event: MouseEvent | TouchEvent) => {
    if (
      iconRef.current &&
      event.target instanceof Node &&
      iconRef.current.contains(event.target)
    ) {
      return;
    }
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  return (
    <RightAlignedContainer>
      <RoundPlusIcon ref={iconRef} onClick={handleClick}>
        +
      </RoundPlusIcon>
      <ClickAwayListener onClickAway={handleClose}>
        <Popper open={open} anchorEl={anchorEl} placement="bottom-end">
          <SelectPopperWrapper>
            <SelectPopperList>
              {items.map((item, index) => (
                <SelectPopperListItem key={index}>
                  <SelectPopperListItemText onClick={item.onClick}>
                    {item.text}
                  </SelectPopperListItemText>
                </SelectPopperListItem>
              ))}
            </SelectPopperList>
          </SelectPopperWrapper>
        </Popper>
      </ClickAwayListener>
    </RightAlignedContainer>
  );
}
